import { RootState } from "redux/reducers/rootReducer";
import { createSelector } from "reselect";

export const getLocationState = (state: RootState) => state.location;
export const getUserLocation = createSelector(
  [getLocationState],
  (location) => location?.location
);
export const getCountryCode = createSelector(
  [getLocationState],
  (location) => location.countryCode
);

export const getCity = createSelector(
  [getLocationState],
  (location) => location.city
);
export const getGeoSlug = createSelector(
  [getLocationState],
  (location) => location.geoSlug
);
export const getState = createSelector(
  [getLocationState],
  (location) => location.state
);

export const getLocationLoaded = createSelector(
  [getLocationState],
  (state) => !!state.location
);
